import { render } from "./BulkUserUpdateModal.vue?vue&type=template&id=32e03860&scoped=true&ts=true"
import script from "./BulkUserUpdateModal.vue?vue&type=script&lang=ts"
export * from "./BulkUserUpdateModal.vue?vue&type=script&lang=ts"

import "./BulkUserUpdateModal.vue?vue&type=style&index=0&id=32e03860&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e03860"]])

export default __exports__